<router-outlet></router-outlet>

<ngx-spinner [fullScreen]="true" type="custom">
   <div class="custom-spinner" style="display: flex;flex-direction: column;gap:5px;">
        <img src="../assets/logo.jpg" alt="Logo">
        <p style="font-size: 20px; color: white">Loading...</p>
      </div>
  </ngx-spinner>
